import { PDFDocument, StandardFonts, rgb } from "pdf-lib";

// @ts-expect-error
import pdfIcon from "../ParcelDetails/pdfIcon.png";

// @ts-expect-error
import legendImage from "./legend.png";

const calculateTextHeight = (
  doc,
  text,
  maxWidth,
  fontSize,
  lineHeightFactor = 1
) => {
  doc.setFontSize(fontSize);
  const lines = doc.splitTextToSize(text, maxWidth);
  return lines.length * 5;
  return lines > 5 ? 0 : fontSize * lineHeightFactor * lines.length;
  // const lineHeight = fontSize * lineHeightFactor;
  // return lines.length * lineHeight;
};

function toDataURL(url) {
  return new Promise((resolve, reject) => {
    var xhr = new XMLHttpRequest();
    xhr.onload = function () {
      var reader = new FileReader();
      reader.onloadend = function () {
        resolve(reader.result);
      };
      reader.readAsDataURL(xhr.response);
    };
    xhr.open("GET", url);
    xhr.responseType = "blob";
    xhr.send();
  });
}

const font = "courier";

interface Colors {
  headerTextColor: [number, number, number];
  sectionHeaderTextColor: [number, number, number];
  tableHeaderBackgroundColor: [number, number, number];
  tableHeaderTextColor: [number, number, number];
}

export const printParcelDetails = async (
  doc,
  data,
  startHeight,
  colors: Colors
) => {
  colors.headerTextColor = colors.headerTextColor || [255, 255, 255];
  colors.sectionHeaderTextColor = colors.sectionHeaderTextColor || [0, 0, 0];
  colors.tableHeaderBackgroundColor = colors.tableHeaderBackgroundColor || [
    0, 0, 0,
  ];
  colors.tableHeaderTextColor = colors.tableHeaderTextColor || [255, 255, 255];

  const verticalMargin = 5;
  const horizontalMargin = 5;
  const borderHorizontalMargin = 3;
  const borderVerticalMargin = 3;
  const pageWidth = doc.internal.pageSize.width;
  const halfPageWidth = Math.floor(pageWidth / 2);
  const tableWidth = halfPageWidth - horizontalMargin;
  let currentY = startHeight;

  const createHeaderWithLineBelow = (doc, text, y, side) => {
    const lineOffset = 1;
    doc.setFontSize(9);
    doc.setFont("times", "bold");
    doc.setTextColor(...colors.sectionHeaderTextColor);

    if (side === "left") {
      doc.text(text, horizontalMargin, y);
      doc.line(horizontalMargin, y + lineOffset, halfPageWidth, y + lineOffset);
    } else if (side === "right") {
      const x = halfPageWidth + horizontalMargin;
      doc.text(text, x, y);
      doc.line(
        x,
        y + lineOffset,
        doc.internal.pageSize.width - horizontalMargin,
        y + lineOffset
      );
    } else {
      doc.text(text, horizontalMargin, y);
      doc.line(
        horizontalMargin,
        y + lineOffset,
        doc.internal.pageSize.width - horizontalMargin,
        y + lineOffset
      );
    }
    doc.setFont(font);
    doc.setLineWidth(0.3);
    doc.setDrawColor(128);
    doc.setTextColor(0);
  };
  doc.setDrawColor(128);
  doc.setLineWidth(0.5);
  if (currentY !== 10) {
    doc.addPage();
    currentY = 10;
  }
  doc.rect(
    borderHorizontalMargin,
    borderVerticalMargin,
    pageWidth - borderHorizontalMargin * 2,
    doc.internal.pageSize.height - borderVerticalMargin * 2
  );
  doc.setFont(font, "bold");
  doc.setFontSize(11);
  doc.setTextColor(...colors.headerTextColor);
  doc.text(
    `Parcel Number: ${data.ParcelNumber}     Year: ${data.Year}`,
    horizontalMargin,
    10
  );
  doc.setFont(font, "normal");
  doc.line(
    borderHorizontalMargin,
    currentY + 2,
    pageWidth - borderHorizontalMargin,
    currentY + 2
  );
  currentY += 10;

  createHeaderWithLineBelow(doc, "PARCEL DETAILS", currentY, "left");

  createHeaderWithLineBelow(doc, "LEGAL DESCRIPTION", currentY, "right");
  doc.setFont(font, "normal");
  currentY += 5;

  // const legalDescriptionHeight = 50;
  const legalDescriptionHeight = calculateTextHeight(
    doc,
    data.LegalDescription,
    halfPageWidth,
    10
  );

  doc.text(data.LegalDescription, halfPageWidth + horizontalMargin, currentY);

  // const legalDescriptionHeight =
  //   doc.getTextDimensions(data.LegalDescription).y + currentY;
  const standardLegalDescriptionHeight = 15;
  const legalDescriptionExcessHeight =
    legalDescriptionHeight - standardLegalDescriptionHeight;

  // const legalDescriptionHeight = 50;

  createHeaderWithLineBelow(
    doc,
    "SALES",
    currentY + verticalMargin + 10 + legalDescriptionExcessHeight,
    "right"
  );
  const salesTableOptions = getAutoTableOptions(
    [["Date of Sale", "Amount"]],
    data.Sales.map((sale) => Object.values(sale)),
    colors
  );

  doc.autoTable({
    ...salesTableOptions,
    tableWidth: tableWidth - horizontalMargin,
    margin: { left: halfPageWidth + horizontalMargin },
    startY:
      currentY +
      verticalMargin +
      verticalMargin +
      10 +
      legalDescriptionExcessHeight,
  });

  createHeaderWithLineBelow(
    doc,
    "LOT ACRES",
    doc.autoTable.previous.finalY + verticalMargin * 2,
    "right"
  );

  const lotAcreRow = [
    data.LotAcre.LotSize === "" ? "-" : data.LotAcre.LotSize,
    data.LotAcre.HomeSize === "" ? "-" : data.LotAcre.HomeSize,
    data.LotAcre.Farm === "" ? "-" : data.LotAcre.Farm,
    data.LotAcre.GrossAcres === "" ? "-" : data.LotAcre.GrossAcres,
  ];

  const lotAcresTableOptions = getAutoTableOptions(
    [["Lot size", "Homesite", "Farm", "Gross Acres"]],
    [lotAcreRow],
    colors
  );

  doc.autoTable({
    ...lotAcresTableOptions,
    tableWidth: tableWidth - horizontalMargin,
    margin: { left: halfPageWidth + horizontalMargin },
    startY: doc.autoTable.previous.finalY + verticalMargin * 3,
  });

  doc.setFontSize(10);
  const leftPanel = [
    { label: "Township", key: "TownshipName" },
    { label: "Tax Code", key: "TaxCode" },
    { label: "Tax Status", key: "TaxStatus" },
    { label: "Property Class", key: "PropertyClass" },
    { label: "Assessed Value", key: "AssessedValue" },
    { label: "Net Taxable Value", key: "NetTaxableValue" },
    { label: "Tax Rate", key: "TaxRate" },
    { label: "Total Tax", key: "TotalTax" },
  ];

  for (let i = 0; i < leftPanel.length; i++) {
    const { label, key } = leftPanel[i];
    if (!data[key]) continue;
    doc.setFont(font, "bold");
    doc.text(`${label}`, pageWidth / 4 - 5, currentY, { align: "right" });
    doc.setFont(font, "normal");
    doc.text(data[key], pageWidth / 4 - 2, currentY, {
      align: "left",
    });

    currentY += 5;
  }

  currentY += verticalMargin;
  createHeaderWithLineBelow(doc, "SITE ADDRESS", currentY, "left");
  currentY += 5;
  doc.setFont(font, "normal");
  doc.text(data.SiteAddress, horizontalMargin, currentY);
  currentY += verticalMargin * 3;

  if (doc.autoTable.previous.finalY > currentY) {
    // currentY = doc.autoTable.previous.finalY + verticalMargin;
  }

  createHeaderWithLineBelow(doc, "RELATED NAMES", currentY, "left");

  const relatedNamesTableOptions = getAutoTableOptions(
    [["Name", "Relationship"]],
    data.RelatedNames.map((name) => Object.values(name)),
    colors
  );

  doc.autoTable({
    ...relatedNamesTableOptions,
    tableWidth,
    margin: { left: horizontalMargin },
    startY: currentY + 5,
  });

  currentY = doc.autoTable.previous.finalY + verticalMargin;

  doc.setFontSize(10);

  createHeaderWithLineBelow(doc, "EXEMPTIONS", currentY, "right");
  const exemptionTableOptions = getAutoTableOptions(
    [["Exemption Type", "Active Date", "Amount"]],
    data.Exemptions.map((exemption) => Object.values(exemption)),
    colors
  );

  doc.autoTable({
    ...exemptionTableOptions,
    tableWidth: tableWidth - horizontalMargin,
    margin: { left: halfPageWidth + horizontalMargin },
    startY: currentY + 5,
  });
  const exemptionEndingY = doc.autoTable.previous.finalY;

  createHeaderWithLineBelow(doc, "TAX RATES", currentY, "left");
  const taxRatesTableOptions = getAutoTableOptions(
    [["Tax District", "Tax Rate", "Amount"]],
    data.TaxRates.map((rate) => Object.values(rate)),
    colors
  );
  doc.autoTable({
    ...taxRatesTableOptions,
    tableWidth,
    margin: { left: horizontalMargin },
    startY: currentY + 5,
  });
  let taxRatesEndingY = doc.autoTable.previous.finalY;

  const remainingSpace = doc.internal.pageSize.height - taxRatesEndingY;
  if (remainingSpace < 100) {
    doc.addPage();
    taxRatesEndingY = verticalMargin;
  }

  const assessmentTableOptions = getAutoTableOptions(
    [
      [
        "Category",
        "Land/Lot",
        "Improvements",
        "Farm Land",
        "Farm Building",
        "Mineral",
        "Total",
      ],
    ],
    data.Assessments.map((row) => Object.values(row)),
    colors
  );

  doc.autoTable({
    ...assessmentTableOptions,
    tableWidth: pageWidth - horizontalMargin * 2,
    margin: { left: horizontalMargin },
    startY: taxRatesEndingY + verticalMargin + verticalMargin,
  });
  createHeaderWithLineBelow(
    doc,
    "ASSESSMENTS",
    taxRatesEndingY + verticalMargin,
    "full"
  );

  const assessmentEndingY = doc.autoTable.previous.finalY;

  createHeaderWithLineBelow(
    doc,
    "ELECTRONIC DOCUMENTS",
    assessmentEndingY + verticalMargin,
    "full"
  );
  currentY =
    assessmentEndingY + verticalMargin + verticalMargin + verticalMargin;
  for (let i = 0; i < data.ElectronicDocuments.length; i++) {
    const { Name, ID } = data.ElectronicDocuments[i];
    doc.setFontSize(10);
    doc.setTextColor(0, 0, 255);

    const base64Img = await toDataURL(pdfIcon);
    doc.addImage(
      base64Img,
      "PNG",
      horizontalMargin,
      currentY - 5,
      8,
      8,
      "icon" + i
    );
    const imageSpace = 10;

    doc.textWithLink(Name, horizontalMargin + imageSpace, currentY, {
      url: `https://publicrecords.mchenrycountyil.gov/AppNet/docpop/docpop.aspx?clienttype=html&docId=${ID}`,
    });
    doc.setTextColor(0);
    const width = doc.getTextWidth(Name);
    doc.setDrawColor(0, 0, 255);
    doc.line(
      horizontalMargin + imageSpace,
      currentY + 1,
      horizontalMargin + width + imageSpace,
      currentY + 1
    );
    doc.setDrawColor(0);
    currentY += 10;
  }

  // createHeaderWithLineBelow(
  //   doc,
  //   "PAYMENTS",
  //   assessmentEndingY + verticalMargin,
  //   "full"
  // );
  // const paymentTableOptions = getAutoTableOptions(
  //   [
  //     [
  //       {
  //         content: "Installment",
  //         colSpan: 1,
  //         styles: { halign: "center" },
  //       },
  //       { content: "Billed", colSpan: 5, styles: { halign: "center" } },
  //       { content: "Payment", colSpan: 4, styles: { halign: "center" } },
  //     ],
  //     [
  //       "Due",
  //       "Tax",
  //       "Penalty",
  //       "Cost",
  //       "Drainage",
  //       "Total",
  //       "Paid",
  //       "Date",
  //       "Batch No.",
  //       "Receipt No.",
  //     ],
  //   ],
  //   data.Payments.map((row) => Object.values(row))
  // );
  // doc.autoTable({
  //   ...paymentTableOptions,
  //   tableWidth: pageWidth - horizontalMargin * 2,
  //   margin: { left: horizontalMargin },
  //   startY: assessmentEndingY + verticalMargin + verticalMargin,
  // });

  doc.setLineWidth(0.5);
  doc.rect(
    borderHorizontalMargin,
    borderVerticalMargin,
    pageWidth - borderHorizontalMargin * 2,
    currentY + borderVerticalMargin
  );
};

export const getAutoTableOptions = (headers, rows, colors) => {
  return {
    head: headers,
    body: rows,
    headStyles: {
      fontWeight: "bold",
      fillColor: colors.tableHeaderBackgroundColor,
      textColor: colors.tableHeaderTextColor,
    },
    styles: {
      lineColor: [0, 0, 0],
      lineWidth: 0.1,
      cellPadding: 1,
      lineHeight: 1.2,
      fontSize: 10,
      font,
    },
    didParseCell: function (data) {
      if (data.row.section === "body") {
        if (data.row.index % 2 === 0) {
          data.cell.styles.fillColor = [249, 246, 223];
        } else {
          data.cell.styles.fillColor = [255, 255, 255];
        }
      }
    },
    // showHead: "firstPage",
  };
};
export const getDataUrlFromArrayBuffer = (
  arrayBuffer: ArrayBuffer,
  type: string = "application/pdf"
) => {
  const blob = new Blob([arrayBuffer], { type });
  return URL.createObjectURL(blob);
};

export const mergePdfs = async (pdfsToMerge: ArrayBuffer[]) => {
  const mergedPdf = await PDFDocument.create();
  for (const pdfBuffer of pdfsToMerge) {
    const pdf = await PDFDocument.load(pdfBuffer);
    const copiedPages = await mergedPdf.copyPages(pdf, pdf.getPageIndices());
    copiedPages.forEach((page) => {
      mergedPdf.addPage(page);
    });
  }
  const mergedPdfFile = await mergedPdf.save();
  return mergedPdfFile;
};

export const addDisclaimer = async (pdfBuffer: ArrayBuffer) => {
  const pdfDoc = await PDFDocument.load(pdfBuffer);
  const pages = pdfDoc.getPages();
  const firstPage = pages[0];
  const height = firstPage.getHeight();
  const courierFont = await pdfDoc.embedFont(StandardFonts.Courier);
  const startOffset = height - 80;
  const startX = 50;
  const lineSpacing = 10;

  firstPage.drawRectangle({
    x: startX - 10,
    y: startOffset - 30,
    width: 310,
    height: 50,
    color: rgb(1, 1, 1),
    opacity: 0.6,
    borderWidth: 1,
  });

  firstPage.drawText(
    `Copyright County of McHenry ${new Date().getFullYear()}.`,
    {
      x: startX,
      y: startOffset,
      size: 10,
      font: courierFont,
    }
  );
  firstPage.drawText("All information is provided 'as-is' with no", {
    x: startX,
    y: startOffset - lineSpacing,
    size: 10,
    font: courierFont,
  });
  firstPage.drawText("guarantee of accuracy, completeness, or currency.", {
    x: startX,
    y: startOffset - lineSpacing - lineSpacing,
    size: 10,
    font: courierFont,
  });

  const pdfBytesUpdated = await pdfDoc.save();
  return pdfBytesUpdated;
};

export const addLegendImage = async (pdfBuffer: ArrayBuffer) => {
  const pdfDoc = await PDFDocument.load(pdfBuffer);
  const pages = pdfDoc.getPages();
  const lastPage = pages[pages.length - 1];
  const newPage = pdfDoc.addPage([lastPage.getWidth(), lastPage.getHeight()]);
  const { width, height } = newPage.getSize();
  const res = await fetch(legendImage);
  const legendImageBytes = await res.arrayBuffer();
  const _legendImage = await pdfDoc.embedPng(legendImageBytes);
  const legendImageDims = _legendImage.scale(0.7);
  // center the image in the top middle of the page
  newPage.drawImage(_legendImage, {
    x: width / 2 - legendImageDims.width / 2,
    y: height - legendImageDims.height - 10,
    width: legendImageDims.width,
    height: legendImageDims.height,
  });
  // newPage.drawImage(_legendImage, {
  //   x: width - legendImageDims.width - 10,
  //   y: height - legendImageDims.height - 10,
  //   width: legendImageDims.width,
  //   height: legendImageDims.height,
  // });
  const pdfBytesUpdated = await pdfDoc.save();
  return pdfBytesUpdated;
};
